import {
    type SubscriptionPreferenceCreateOrUpdateRequest,
    type UserGlobalPreferenceUpdateRequest,
    type UserPreferenceUpdateRequest,
} from '@lightdash/common';

export enum EventName {
    SAVE_PREFERENCE_CLICKED = 'save_preference_clicked',
    GLOBAL_PREFERENCE_UPDATE_CLICKED = 'global_preference_update_clicked',
    UNSUBSCRIBE_BUTTON_CLICKED = 'unsubscribe_button_clicked',
}

type SavePreferenceClickedEvent = {
    name: EventName.SAVE_PREFERENCE_CLICKED;
    payload: UserPreferenceUpdateRequest;
};

type GlobalPreferenceUpdateClickedEvent = {
    name: EventName.GLOBAL_PREFERENCE_UPDATE_CLICKED;
    payload: UserGlobalPreferenceUpdateRequest;
};

type UnsubscribeButtonClickedEvent = {
    name: EventName.UNSUBSCRIBE_BUTTON_CLICKED;
    payload: SubscriptionPreferenceCreateOrUpdateRequest;
};

export type EventData =
    | SavePreferenceClickedEvent
    | GlobalPreferenceUpdateClickedEvent
    | UnsubscribeButtonClickedEvent;
